export default __webpack_public_path__ + "static/media/parents-logo.e637b946.svg";